import { bindActionCreators } from 'redux';
import { Action, POPOUP_HIDE, POPOUP_SHOW } from '.'
import store from './../reducers';

export default bindActionCreators({
    show: (path, data) => Action(POPOUP_SHOW, {path, data}),
    close: (path, id) => Action(POPOUP_HIDE, {path, id}),
}, store.dispatch);


// WEBPACK FOOTER //
// ./src/actions/popup.js